import { render, staticRenderFns } from "./Wp_jd_getlink.vue?vue&type=template&id=6ce0e3fd&scoped=true&"
import script from "./Wp_jd_getlink.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_getlink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce0e3fd",
  null
  
)

export default component.exports